import React, { useState } from 'react';
import logo from './logo.svg';
import './App.css';
import puzzleSegments from './segments.json';

type Question = {
  text: string;
  answers: string[];
  correct: number | number[];
  level: number;
};

type PuzzleSegment = {
  title: string;
  image: string;
  introduction: string;
  questions: Question[];
};

function App() {
  return (
    <div className="App">
       <Game segments={puzzleSegments} />
    </div>
  );
}

function Game({ segments }: { segments: PuzzleSegment[] }) {
  const [gameStarted, setGameStarted] = useState(false);

  const handleStartGame = () => {
    setGameStarted(true);
  };

  return (
    <div>
      {!gameStarted ? (
        <div className="Game-start">
          <div>Other Kitten</div>
          <img src={logo} className="App-logo" alt="logo" />
          <div>Lost In Time</div>
          <div className="scrollable-text">
            <p>You are a historian—or at least, you thought you were—until the day you found Otherkitten, a mysterious cat with an uncanny ability to vanish and reappear in different historical periods. One morning, Otherkitten swats at a strange glowing object on your desk, and suddenly, time distorts around you.</p>
            <p>A time rift opens, pulling you and Otherkitten into a strange temporal limbo. A cryptic message appears:</p>
            <blockquote>"Time is broken. The only way forward is through the past."</blockquote>
            <p>You realize that to return home, you must navigate through 10 crucial moments in history, solving puzzles to restore the timeline. Otherkitten, somehow tied to these anomalies, appears in each era—sometimes as a clue, sometimes as a troublemaker.</p>
            <p>Every puzzle is a test:</p>
            <ul>
              <li>Solve it correctly, and you move forward.</li>
              <li>Fail, and time itself unravels a little more…</li>
            </ul>
            <p>Your only hope? Use your knowledge of history, follow the cat, and solve the mysteries before time collapses forever.</p>
          </div>
          <button onClick={handleStartGame}>Start Game</button>
        </div>
      ) : (
        segments.map((segment, segmentIndex) => (
          <div key={segmentIndex}>
            <h2>{segment.title}</h2>
            <img src={segment.image} alt={segment.title} />
            <p>{segment.introduction}</p>
            
            {segment.questions.map((question, questionIndex) => (
              <div key={questionIndex}>
                <h3>Question {questionIndex + 1}</h3>
                <p>{question.text}</p>
                <ul>
                  {question.answers.map((answer, answerIndex) => (
                    <li key={answerIndex}>
                      {answer}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        ))
      )}
    </div>
  );
}

export default App;
